import { render, staticRenderFns } from "./BlockType106.vue?vue&type=template&id=470a26dc&scoped=true"
import script from "./BlockType106.vue?vue&type=script&lang=ts"
export * from "./BlockType106.vue?vue&type=script&lang=ts"
import style0 from "./BlockType106.vue?vue&type=style&index=0&id=470a26dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470a26dc",
  null
  
)

export default component.exports